<template>
    <transition name="vue-table-loader">
        <div class="vue-table-loader master-loader" v-if="isLoaded"><span class="fa fa-cog fa-spin fa-3x"></span></div>
    </transition>
</template>

<script>
export default {
    name: 'master-loader',
    props: ['isLoaded'],
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
